var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmissionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.25C23.0711 23.25 24.75 21.5711 24.75 19.5C24.75 17.4289 23.0711 15.75 21 15.75C18.9289 15.75 17.25 17.4289 17.25 19.5C17.25 21.5711 18.9289 23.25 21 23.25Z",
    stroke: "#CC0000",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 33C14.25 29.25 17.25 26.25 21 26.25C22.5 26.25 23.85 26.7 24.75 27.45",
    stroke: "#CC0000",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.5V34.5",
    stroke: "#CC0000",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 30H34.5",
    stroke: "#CC0000",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionActive);
export default __webpack_public_path__ + "static/media/admission-active.cb921726578d75d1ca7730cb8f8b9cae.svg";
export { ForwardRef as ReactComponent };